module.exports = __webpack_public_path__ + "static/media/slika2.555b50f5.png";